import React from 'react';

export default function (props, state) {
  return (
    <div>
      {
        props.pages.map((isActive, index) => {
          const bubbleStyle = {
            width: "0.25em",
            height: "0.25em",
            margin: "1em auto",
            background: isActive ? "#6EFFDF" : "#555",
          };
          //true or false
          return <div key={index} style={bubbleStyle} />
        })
      }
    </div>
  )
}

//props.pages = [true, false, false] for 3 pages, first one being active


// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionListViewPaginationGroup.js